export default __webpack_public_path__ + "static/media/23.f04b75ee.jpg";